export enum OtherAccessEnum {
  SPK = 'spk'
}
